import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={38}
    height={5}
    viewBox="0 0 38 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={2}
      y={2}
      width={36}
      height={1}
      fill={`url(#paint0_linear_16206_5443_${Date.now()})`}
    />
    <path
      d="M2.09437 0.581645C2.15833 0.393095 2.425 0.393096 2.48896 0.581645L2.87993 1.73428C2.89942 1.79173 2.94298 1.83783 2.99924 1.86054L4.10476 2.30681C4.27856 2.37697 4.27856 2.62303 4.10476 2.69319L2.99924 3.13946C2.94298 3.16217 2.89942 3.20827 2.87993 3.26572L2.48896 4.41835C2.425 4.6069 2.15833 4.6069 2.09437 4.41835L1.7034 3.26572C1.68392 3.20827 1.64035 3.16217 1.5841 3.13946L0.478574 2.69319C0.304775 2.62303 0.304775 2.37697 0.478573 2.30681L1.5841 1.86054C1.64035 1.83783 1.68392 1.79173 1.7034 1.73428L2.09437 0.581645Z"
      fill={props.fill || "#C0DCFF"}
    />
    <defs>
      <linearGradient
        id={`paint0_linear_16206_5443_${Date.now()}`}
        x1={2}
        y1={2.5}
        x2={38}
        y2={2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill || "#C0DCFF"} />
        <stop offset={1} stopColor={props.fill || "#C0DCFF"} stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
